// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__Ovtnz","modal":"Modal_modal__ZjBx1","closeButton":"Modal_closeButton__tS-aC"};